/**
 * Checks whether plan has no end date, meaning the user will be charged until the plan is canceled.
 * Both recurring and one time plans can be unlimited.
 * @returns true if plan is unlimited.
 */

export const isUnlimitedPlan = plan => {
  if (plan.pricing?.subscription) {
    return plan.pricing?.subscription.cycleCount === 0;
  }
  return !!plan.pricing?.singlePaymentUnlimited;
};
//# sourceMappingURL=is-unlimited-plan.js.map